import { Injectable } from '@angular/core';
declare var fbq: any; 

@Injectable({
  providedIn: 'root'
})
export class FacebookPixelService {

  private isLoaded = false;

  constructor() { }

  loadPixel(pixelId: string): void {
    if (!this.isLoaded) {
      ((f: any, b, e, v, n, t, s) => {
        if (f.fbq) return; n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = true; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = true;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      fbq('init', pixelId);
      this.isLoaded = true;
    }
  }

  trackRegistrationComplete(): void {
    if (this.isLoaded) {
      fbq('track', 'CompleteRegistration');
    }
  }
}
